module.exports = __webpack_public_path__ + "static/img/formwork.30f5c4b2.png";